module.exports = __webpack_public_path__ + "static/media/upload_data_validation_screen.028d5ed7.mov";